import React, { useState, useEffect } from "react";
import { Modal, Form, Switch, Card, Input, notification } from "antd";
import Button from "./button";
import Close from "../../assets/icons/close.svg";
import colors from "../../share/constants/constants";
import { applyVariantQuantityLimit } from "../../api/service";

const ApplyVariantQuantityLimitModal = ({ onCancel, data, title, getServiceDetails, service, getBusinessDetails }) => {
  const [form] = Form.useForm();
  const [inProgress, setInProgress] = useState(false);
  const [applyLimit, setApplyLimit] = useState(false);
  const [restrictedOrderQuantity, setRestrictedOrderQuantity] = useState(null);

  const onFinish = async (value) => {
    setInProgress(true);
    try {
      const response = await applyVariantQuantityLimit(service?._id, applyLimit, restrictedOrderQuantity);
      if (response) {
        setInProgress(false);
        onCancel();
        notification.success({
          message: 'Update Successful',
          description: response.message,
        });
        getBusinessDetails();
      }
    } catch (error) {
      setInProgress(false);
    }
  };

  useEffect(() => {
    if (service?.isPerOrderQuantityRestricted !== undefined) {
      setApplyLimit(service.isPerOrderQuantityRestricted);
    }
  }, [service]);

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="450px"
        onCancel={onCancel}
      >
        <Card className="border-2 px-2">
          <div className="flex">
            <h2 className="flex-1">{title || "Set Quantity Limit for Variants"}</h2>
            <img src={Close} alt="Close Icon" className="w-3.2 cursor-pointer" onClick={onCancel} />
          </div>
          <p className="text-gray-600 text-sm mt-2">
            This setting restricts users from adding more than the allowed quantity per order. Once enabled, users can only purchase up to the specified limit.
          </p>

          <Form form={form} onFinish={onFinish}>
            <div>
              <Form.Item name="applyLimit" valuePropName="checked">
                <div className="flex items-center">
                  <Switch
                    checked={applyLimit}
                    onChange={(checked) => setApplyLimit(checked)}
                  />
                  <span className="ml-2">Restrict Max Items per User</span>
                </div>
              </Form.Item>
            </div>

            <div className="mt-[-15px]">
              <Form.Item 
                name="restrictedOrderQuantity" 
                label="Restricted Order Quantity"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  type="number"
                  defaultValue={service?.restrictedOrderQuantity}
                  onChange={(e) => setRestrictedOrderQuantity(e.target.value)}
                  placeholder="Enter restricted quantity"
                  className="w-full mt-1.5 h-5.4"
                />
              </Form.Item>
            </div>

            <Form.Item className="flex justify-center mt-2.5">
              <Button
                title={"Save Changes"}
                color={colors.primaryPurple}
                htmlType="submit"
                className="flex items-center w-full"
                loading={inProgress}
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};

export default ApplyVariantQuantityLimitModal;
